import { Form, Input, InputNumber } from "antd";
import { useIntl } from "react-intl";

import { FormFieldContainer } from "./styled";

export const GenericFormField = () => {
  const intl = useIntl();

  return (
    <FormFieldContainer>
      <Form.Item
        name="label"
        label={intl.formatMessage({ id: "newFormField.fieldLabel" })}
        rules={[
          {
            required: true,
            message: intl.formatMessage({
              id: "newFormField.fieldLabelRequired",
            }),
          },
        ]}
      >
        <Input />
      </Form.Item>
      <Form.Item
        name="placeholder"
        label={intl.formatMessage({ id: "newFormField.placeholder" })}
      >
        <Input />
      </Form.Item>
      <Form.Item
        name="requiredValidationText"
        label={intl.formatMessage({ id: "newFormField.validationErrorText" })}
      >
        <Input />
      </Form.Item>
      <Form.Item
        name="maxCharacterLength"
        label={intl.formatMessage({ id: "newFormField.maxCharacterLength" })}
      >
        <InputNumber />
      </Form.Item>
    </FormFieldContainer>
  );
};
